import { addToCart } from "../helpers/cart";

class CartAdd extends HTMLElement {
	constructor() {
		super();

		/* Limit add to cart off quantity */
		this.addCount = 0;
		this.addLimit = this.dataset.addLimit || false;

		this.addEventListener("click", this.add.bind(this));
	}

	add(event) {
		event.preventDefault();
		event.stopPropagation();
		const buttonEl = event.target.closest("cart-add");
		const variantId = buttonEl.dataset.id;

		//Update text, reset it after delay
		const buttonChild = buttonEl.querySelector("button");
		const textWas = buttonChild.innerText;
		buttonChild.innerText = "Added to Cart";

		//Add an item to cart, page will react
		// TODO: Switch to real based off of quantity remaining.
		addToCart(variantId, 1, {}, (res) => {
			buttonChild.innerText = textWas;

			if (this.addLimit) {
				this.addCount++;
				if (this.addCount >= this.addLimit) {
					buttonChild.setAttribute("disabled", true);
				}
			}
		});

	}
}

export default CartAdd;
